export default __webpack_public_path__ + "static/media/undraw_Maintenance_re_59vn.8f617ca2.svg";